import { HomePost, HomeVideo } from '../components/public/HomeSections';

export const youtubeVideoId = (url: string): string | null => {
    try {
        const parsed = new URL(url);
        if (parsed.protocol !== 'https:') return null;
        const id = parsed.hostname === 'youtu.be' ? parsed.pathname.slice(1)
            : ['youtube.com', 'www.youtube.com', 'm.youtube.com'].includes(parsed.hostname) ? parsed.searchParams.get('v') : null;
        return id && /^[A-Za-z0-9_-]{11}$/.test(id) ? id : null;
    } catch { return null; }
};

export const videoDiscussionHref = (video: HomeVideo) => {
    const id = youtubeVideoId(video.youtubeUrl);
    return id ? `#/watch?video=${id}` : '#/watch';
};

const prompts: Record<string, { question: string; angles: string[]; category: string }> = {
    YwaNjrIuEOk: { question: '처음 실무에 들어간 개발자는 무엇부터 물어봐야 할까요?', angles: ['학교에서 배운 것과 실제 작업 사이의 차이', '작은 게시판 하나로 익힐 수 있는 일', '선배에게 질문을 잘 건네는 방법'], category: 'IT' },
    H5LnsiWr4J0: { question: '새로운 분야에 늦게 들어갈 때 가장 필요한 준비는 무엇일까요?', angles: ['경력을 설명하는 방법', '처음 맡을 수 있는 일의 범위', '불안을 구체적인 질문으로 바꾸기'], category: 'IT' },
    BWDqgrlDGf0: { question: '힘든 초반 경력을 배움으로 남기려면 무엇을 기록해야 할까요?', angles: ['반복해서 막히는 지점', '도움을 요청할 때 필요한 정보', '성장을 판단할 나만의 기준'], category: 'IT' },
    hMzjKPkXRfk: { question: 'SI라는 일을 알아볼 때 어떤 질문부터 해야 할까요?', angles: ['실제 맡을 업무', '협업하는 사람과 방식', '근무 조건을 확인하는 방법'], category: 'IT' },
    '1cz8tBzgpd8': { question: '작은 AI 활용 중 내 일에 실제로 도움이 된 것은 무엇인가요?', angles: ['반복 업무에서 아낀 시간', '결과를 검토하는 방법', '쓰지 않는 편이 나았던 순간'], category: 'AI' }
};

export const discussionForVideo = (video: HomeVideo) => {
    const id = youtubeVideoId(video.youtubeUrl);
    return (id && prompts[id]) || {
        question: '이 영상을 보고 어떤 질문이 생겼나요?',
        angles: ['영상에서 확인하고 싶은 주장', '내 경험과 달랐던 부분', '다른 사람에게 묻고 싶은 점'],
        category: /AI|인공지능/i.test(video.title) ? 'AI' : 'IT'
    };
};

export const relatedVideoPosts = (posts: HomePost[], video: HomeVideo) => {
    const category = discussionForVideo(video).category;
    return posts.filter((post) => post.category === category && Number.isFinite(post.id))
        .sort((a, b) => b.id - a.id).slice(0, 4);
};
